import { Theme } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    step: {
      display: 'flex',
      flexDirection: 'column',
      padding: '1px 1px 0 1px',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      borderRadius: 4,
      border: `1px solid ${Theme.grey30}`,
    },
    stepDescriptionContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: 24,
      alignItems: 'center',
      gap: 24,
      alignSelf: 'stretch',
      borderRadius: '4px 4px 0 0',
      borderBottom: `1px solid ${Theme.grey30}`,
      background: Theme.grey5,
    },
    stepDescription: {
      display: 'flex',
      flexDirection: 'column',
      '& p': {
        fontSize: 14,
      },
    },
    stepNumber: {
      color: Theme.green,
      fontSize: 12,
      fontWeight: 500,
    },
    stepTitle: {
      color: Theme.greyDark,
      fontSize: 16,
      fontWeight: 500,
    },
    description: {
      margin: 0,
      padding: 0,
    },
    icon: {
      minWidth: 24,
      minHeight: 24,
    },
    stepContentContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: 24,
      gap: 24,
      width: '100%',
    },
  },
  { name: 'StepContainer' },
);

const StepContainer = ({ stepNumber, title, description, icon: Icon, children, className = '' }) => {
  const classes = useStyles();
  return (
    <div className={`${classes.step} ${className}`} data-testid={`step-${stepNumber}`}>
      <div className={classes.stepDescriptionContainer}>
        {Icon && <Icon className={classes.icon} />}
        <div className={classes.stepDescription}>
          {stepNumber && <span className={classes.stepNumber}>STEP {stepNumber}</span>}
          <span className={classes.stepTitle}>{title}</span>
          <p className={classes.description}>{description}</p>
        </div>
      </div>
      <div className={classes.stepContentContainer}>{children}</div>
    </div>
  );
};

StepContainer.propTypes = {
  stepNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  icon: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default StepContainer;
